<div class="dialog-container selection">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>{{ "responsible.selectResponsible" | translate }}</h4>
    <button (click)="dialogRef.close()" class="icon-close"></button>
  </div>
  <div class="container container--search">
    <div class="search-bar">
      <div class="first-row">
        <div class="input-container flex-1">
          <sag-ui-input [(ngModel)]="query.title" (keyup)="keyUp.next($event)" class="flex-1" label="Title" type="text" />
        </div>
      </div>
    </div>
  </div>
  <div class="container container--table">
    <div class="section-container table-section">
      <div #itemContainer class="table-container">
        <div class="item-container">
          @if (pagedData?.items && pagedData?.totalItems !== 0) {
            @for (item of paginatedData; track item.id) {
              <app-template-item (click)="changeSelected(item)" [active]="item.selected" [item]="item" (preview)="preview($event)" [readonly]="true" />
            }
          }
        </div>
        @if (!pagedData) {
          <app-loading-indicator />
        }
      </div>
    </div>
  </div>
  <div class="container container--sticky-bottom">
    <div class="section-container button-container">
      <sag-ui-button (click)="dialogRef.close()" color="secondary" type="button">
        {{ "default.buttons.cancel" | translate }}
      </sag-ui-button>
      <sag-ui-button [disabled]="!value" (click)="closeDialog()" color="primary" type="button">
        {{ "default.buttons.confirm" | translate }}
      </sag-ui-button>
    </div>
  </div>
</div>
